export const steps = ['เลือกรอบอบรมที่ต้องการ', 'อัปเดทข้อมูล', 'ยืนยันตัวตน']
